import { useMemo } from 'react';
import { useAuth } from 'hooks';

export const useCurrentUser = () => {
  const { user } = useAuth();

  if (!user) {
    throw new Error('you-not-registered');
  }

  const fullName = useMemo(() => {
    return [user.firstName, user.lastName].filter((v) => !!v).join(' ');
  }, [user.firstName, user.lastName]);
  return useMemo(() => {
    return {
      ...user,
      fullName,
    };
  }, [user, fullName]);
};
